import { Component, EventEmitter, Output } from '@angular/core';
import { AVAILABLE_VARIABLES, IVariableOption } from '../../data/constants/templates.constants';

@Component({
  selector: 'app-variable-picker',
  templateUrl: './variable-picker.component.html',
  styleUrls: ['./variable-picker.component.scss']
})
export class VariablePickerComponent {
  @Output() onVariableSelected = new EventEmitter<string>();

  availableVariables = AVAILABLE_VARIABLES;
  
  // Agrupar por categoría
  get groupedVariables(): Record<string, IVariableOption[]> {
    return {
      cliente: this.availableVariables.filter(v => v.category === 'cliente'),
      arrendamiento: this.availableVariables.filter(v => v.category === 'arrendamiento'),
      financiero: this.availableVariables.filter(v => v.category === 'financiero'),
      empresa: this.availableVariables.filter(v => v.category === 'empresa')
    };
  }
  
  categories = ['cliente', 'arrendamiento', 'financiero', 'empresa'];
  
  categoryLabels: Record<string, string> = {
    cliente: 'Información del Cliente',
    arrendamiento: 'Datos del Arrendamiento',
    financiero: 'Información Financiera',
    empresa: 'Datos de la Empresa'
  };
}
